import React from 'react';

import type { Cell } from 'react-table';

import TeamNameCell from '../team-name-cell';
import { TestIds } from '../../../../test-utils/tests.consts';

interface Props<T extends Record<string, unknown> = Record<string, unknown>> {
	teamId: number;
	itemsInGroup: number;
	cell: Cell<T, number>;
}

// TODO: improve render logic, particularly pay attention to itemsInGroup part
const TeamGroupCell = <T extends Record<string, unknown>>({ teamId, cell, itemsInGroup }: Props<T>) => {
	const renderedHeader = cell.render('Header');

	return (
		<span data-test-id={TestIds.TEAM_GROUP_CELL} key={cell.column.id}>
			{renderedHeader}: <TeamNameCell teamId={teamId} /> ({itemsInGroup} items)
		</span>
	);
};

export default TeamGroupCell;
